import { Point, Rect, Scale, TranslateScreen2To1 } from "../../.././MyHelpers";
import { SpinAndHoldCommonConfiguration } from "../../../api";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import { Settings } from "../../../Settings";
import { SpinAndHoldBonus } from "./SpinAndHold";
import { SpinAndHoldBonusFactory } from "./SpinAndHoldFactory";
import { SpinAndHoldParams } from "./SpinAndHoldParams";

export  class SpinAndHoldBonus_2Screen extends SpinAndHoldBonus {
	//protected transitionView:HTMLElement=null;
	
	protected PathGame: string = null;

	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
		this.PathGame = Settings.ResourcesFolder + "multigame/slot/"+gameName+"/resources/"
	}

	protected override async BasePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await super.BasePrepare(resourceManager);		
	}



	protected override DesinationComet(): Point {
		//let destination: Point = TranslateScreen2To1(new PixelRect(0, 0, 1920, 1080)).Center();
		let destination: Point = TranslateScreen2To1(new Rect(Scale.X(-450),Scale.Y(300), Scale.W(1920), Scale.H(1080))).Center();

		return destination
	}



	protected override async BaseLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.BaseLoaded(resourceManager);
	}	
}




export class SpinAndHoldBonusFactory_2Screen extends SpinAndHoldBonusFactory {
	public override CreateSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonus {
		return new SpinAndHoldBonus_2Screen(gameName, params, config);
	}
}